function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var _ref = /*#__PURE__*/React.createElement("path", {
  d: "M47.725 28H80v34.216H67V47.763h-5.985v14.453H47.725V28z",
  fill: "#C4C4C4"
});
var _ref2 = /*#__PURE__*/React.createElement("g", {
  mask: "url(#onboarding-s3_svg__a)"
}, /*#__PURE__*/React.createElement("g", {
  opacity: 0.3
}, /*#__PURE__*/React.createElement("circle", {
  cx: 64,
  cy: 47,
  r: 15,
  fill: "#fff"
}), /*#__PURE__*/React.createElement("circle", {
  cx: 64,
  cy: 47,
  r: 15,
  fill: "url(#onboarding-s3_svg__paint0_linear_1513:4068)"
})), /*#__PURE__*/React.createElement("circle", {
  cx: 64,
  cy: 47,
  r: 15,
  stroke: "#fff",
  strokeWidth: 2
}), /*#__PURE__*/React.createElement("circle", {
  cx: 64,
  cy: 47,
  r: 15,
  stroke: "url(#onboarding-s3_svg__paint1_linear_1513:4068)",
  strokeWidth: 2
}));
var _ref3 = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M73 105c-7.76 0-15-5-16.032-8.93-1.033-3.93-1.206-5.159-1.684-8.554-.95-6.864-4.814-10.819-5.71-11.652-.698-1.45-.301-3.057.96-3.792.883-.511 2.233-.977 3.772.887.03.036 3.42 3.424 4.694 7.041v2.5c0 .638.381 1 1 1 .618 0 1-.362 1-1V51c0-1.5 1.495-3 3-3 1.508 0 3 1.5 3 3l.034 18.7V80.98c0 .637.348 1.02.966 1.02s1-.362 1-1V69.5c0-1.742 1.463-3 3-3 1.506 0 3 1.287 3 3V81c0 .638.382 1 1 1 .617 0 1-.362 1-1V71c0-1.714 1.498-3 3-3 1.503 0 3.072 1.754 3.072 3.468L83 82c0 .638.383 1 1 1s1-.362 1-1v-9c0-1.5 1.435-3 3-3 1.491 0 3 2.272 3 4v17.5c-.05 11.94-11.278 13.5-15.5 13.5H73zm20-13.414v-.06V74c0-2.999-2.275-6-5-6-1.046 0-2.5.5-3 1.5-1-2.5-2.561-3.5-5-3.5-1.071 0-2.613.515-3.41 1.13C75 64.5 73.5 64.5 72 64.5c-.993 0-2.5.5-3 1.5V51c0-2.977-2.5-5-5-5s-5 2.023-5 5v24.5c-1.239-2.029-2.92-3.953-2.998-4.047-1.873-2.268-4.202-2.764-6.565-1.395-2.38 1.387-3.14 4.506-1.728 7.1l.102.188.16.137c.043.035 4.164 3.622 5.098 10.362.57 4.037 1.127 7.576 2.176 9.999C56.295 100.267 62.086 107 73 107h2.5c9.823 0 17.05-5.252 17.5-14.367.025-.099 0-.2 0-.307v-.74z",
  fill: "#fff"
});
var _ref4 = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M73 105c-7.76 0-15-5-16.032-8.93-1.033-3.93-1.206-5.159-1.684-8.554-.95-6.864-4.814-10.819-5.71-11.652-.698-1.45-.301-3.057.96-3.792.883-.511 2.233-.977 3.772.887.03.036 3.42 3.424 4.694 7.041v2.5c0 .638.381 1 1 1 .618 0 1-.362 1-1V51c0-1.5 1.495-3 3-3 1.508 0 3 1.5 3 3l.034 18.7V80.98c0 .637.348 1.02.966 1.02s1-.362 1-1V69.5c0-1.742 1.463-3 3-3 1.506 0 3 1.287 3 3V81c0 .638.382 1 1 1 .617 0 1-.362 1-1V71c0-1.714 1.498-3 3-3 1.503 0 3.072 1.754 3.072 3.468L83 82c0 .638.383 1 1 1s1-.362 1-1v-9c0-1.5 1.435-3 3-3 1.491 0 3 2.272 3 4v17.5c-.05 11.94-11.278 13.5-15.5 13.5H73zm20-13.414v-.06V74c0-2.999-2.275-6-5-6-1.046 0-2.5.5-3 1.5-1-2.5-2.561-3.5-5-3.5-1.071 0-2.613.515-3.41 1.13C75 64.5 73.5 64.5 72 64.5c-.993 0-2.5.5-3 1.5V51c0-2.977-2.5-5-5-5s-5 2.023-5 5v24.5c-1.239-2.029-2.92-3.953-2.998-4.047-1.873-2.268-4.202-2.764-6.565-1.395-2.38 1.387-3.14 4.506-1.728 7.1l.102.188.16.137c.043.035 4.164 3.622 5.098 10.362.57 4.037 1.127 7.576 2.176 9.999C56.295 100.267 62.086 107 73 107h2.5c9.823 0 17.05-5.252 17.5-14.367.025-.099 0-.2 0-.307v-.74z",
  fill: "url(#onboarding-s3_svg__paint2_linear_1513:4068)"
});
var _ref5 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
  id: "onboarding-s3_svg__paint0_linear_1513:4068",
  x1: 64,
  y1: 32,
  x2: 64,
  y2: 62,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#fff"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#fff",
  stopOpacity: 0
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "onboarding-s3_svg__paint1_linear_1513:4068",
  x1: 64,
  y1: 31,
  x2: 64,
  y2: 63,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#fff"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#fff",
  stopOpacity: 0
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "onboarding-s3_svg__paint2_linear_1513:4068",
  x1: 70.006,
  y1: 46,
  x2: 70.006,
  y2: 107,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#fff"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#fff",
  stopOpacity: 0
})));
function SvgOnboardingS3(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 140,
    height: 140,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), /*#__PURE__*/React.createElement("mask", {
    id: "onboarding-s3_svg__a",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 47,
    y: 28,
    width: 33,
    height: 35
  }, _ref), _ref2, _ref3, _ref4, _ref5);
}
export default SvgOnboardingS3;